/* Quickshop hover: pill on card hover, size panel, direct add-to-cart.
   Rendered markup lives in snippets/quick-add.liquid; this file is loaded
   once from snippets/scripts.liquid (was previously inlined per card). */
if (!window.quickshopInitialized) {
  window.quickshopInitialized = true;

  var hideTimeouts = new WeakMap();

  function getCard(el) {
    return el.closest('.card-gallery, product-card');
  }

  function closeQuickshop(quickshop) {
    quickshop.classList.remove('is-active', 'is-open');
  }

  // Show the pill when hovering the card.
  document.addEventListener('mouseenter', function (e) {
    var origin = e.target.closest ? e.target.closest('.card-gallery, product-card, .quickshop-hover') : null;
    if (!origin) return;
    var card = getCard(origin);
    if (!card) return;
    var quickshop = card.querySelector('.quickshop-hover');
    if (!quickshop) return;

    var timeout = hideTimeouts.get(card);
    if (timeout) {
      clearTimeout(timeout);
      hideTimeouts.delete(card);
    }
    quickshop.classList.add('is-active');
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var origin = e.target.closest ? e.target.closest('.card-gallery, product-card, .quickshop-hover') : null;
    if (!origin) return;
    var card = getCard(origin);
    if (!card) return;
    var quickshop = card.querySelector('.quickshop-hover');
    if (!quickshop) return;

    var related = e.relatedTarget;
    if (related && (card.contains(related) || quickshop.contains(related))) return;

    var timeout = setTimeout(function () {
      closeQuickshop(quickshop);
      hideTimeouts.delete(card);
    }, 150);
    hideTimeouts.set(card, timeout);
  }, true);

  document.addEventListener('click', async function (e) {
    // Toggle the size panel open.
    var toggle = e.target.closest('[data-quickshop-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var qs = toggle.closest('.quickshop-hover');
      if (qs) qs.classList.add('is-open');
      return;
    }

    // Add a variant to the cart.
    var addBtn = e.target.closest('[data-quickshop-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var variantId = addBtn.dataset.variantId;
      if (!variantId || addBtn.disabled) return;
      await handleAddToCart(addBtn, variantId);
      return;
    }

    // Block clicks bubbling up through the quickshop area to the card link.
    var inside = e.target.closest('.quickshop-hover');
    if (inside) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  async function handleAddToCart(btn, variantId) {
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    try {
      var cartItemsComponent = document.querySelector('cart-items-component');
      var cartSectionId = cartItemsComponent && cartItemsComponent.dataset
        ? cartItemsComponent.dataset.sectionId
        : null;

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: cartSectionId ? [cartSectionId] : [],
          sections_url: window.location.pathname
        })
      });

      if (!res.ok) throw new Error('Add failed');
      var state = await res.json();

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: state,
          sourceId: 'quickshop-hover',
          data: { source: 'quickshop-hover', itemCount: 1, sections: state.sections || {} }
        }
      }));

      btn.textContent = '✓';
      var card = getCard(btn);
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        if (card) {
          var qs = card.querySelector('.quickshop-hover');
          if (qs) qs.classList.remove('is-open');
        }
      }, 1000);
    } catch (err) {
      console.error('[Quickshop] Error:', err);
      btn.textContent = '!';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1200);
    }
  }
}
